import { c as _c } from "react/compiler-runtime";
import MUIMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { styled } from '../styles';
const MenuItemStyled = styled(MUIMenuItem)(() => ({
  minHeight: 48,
  '&.MuiMenuItem-root[hidden]': {
    display: 'none'
  }
}));
const MenuItem = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuItemStyled {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default MenuItem;